import { PAGE_ROUTES } from '@/components/nav/utils/url-builders';
import { isPageActive } from '@/lib/is-page-active';
import {
  hydrateConfirmationHistoryEntries,
  hydrateConfirmations,
  hydrateCustomers,
  hydrateDeals,
  hydrateSMSAgentMessages,
  hydrateUsers,
  hydrateVehiclesAndListingsFromIndexer,
} from '@/models/hydrate';
import { runInAction } from 'mobx';
import { useEffect } from 'react';

const useDealsPageHydrateLatest = () => {
  const isDealsPageActive = isPageActive(PAGE_ROUTES.DEALS);
  const shouldRun = isDealsPageActive;

  useEffect(() => {
    if (!shouldRun) {
      return;
    }

    const hydrateDealsPage = async () => {
      // Dev note: This can be optimized by running this for only the deals above the fold
      // and for just my deals
      await Promise.all([
        hydrateDeals(),
        hydrateCustomers(),
        hydrateVehiclesAndListingsFromIndexer(),
        hydrateUsers(),
        hydrateSMSAgentMessages(),
      ]);

      await Promise.all([
        hydrateConfirmations(),
        hydrateConfirmationHistoryEntries(),
      ]);
    };

    runInAction(async () => {
      await hydrateDealsPage();
    });
  }, [shouldRun]);
};

export default useDealsPageHydrateLatest;
